/**
 * Mise en forme des dates cote client.
 *
 * Le fuseau est celui de la famille, pas celui du telephone : si quelqu'un
 * consulte l'app depuis un autre fuseau, « 09 h 00 » doit rester l'heure du
 * rendez-vous a Montreal, sinon le brief ment.
 *
 * Les fonctions viennent du paquet partage : le Worker les utilise aussi pour
 * rediger la notification.
 */
import { jourLocal } from '@camellie/shared';

export const FUSEAU_FAMILLE = 'America/Toronto';

export { aUneHeure, majuscule } from '@camellie/shared';

import {
  heureAffichee as heureAfficheeBase,
  jourCourt as jourCourtBase,
} from '@camellie/shared';

export function heure(du_le: string): string {
  return heureAfficheeBase(du_le, FUSEAU_FAMILLE);
}

export function jourCourt(du_le: string): string {
  return jourCourtBase(du_le, FUSEAU_FAMILLE);
}

/**
 * Comme jourCourt, mais ajoute l'annee quand elle n'est pas l'annee en cours.
 *
 * Sans elle, « 5 mai » ne permet pas de distinguer mai prochain de mai
 * dernier — exactement l'erreur qu'un assistant peut commettre et qu'un
 * apercu est cense laisser voir.
 */
export function jourCourtAvecAnnee(du_le: string): string {
  const annee = du_le.slice(0, 4);
  const court = jourCourtBase(du_le, FUSEAU_FAMILLE);
  return annee === aujourdhui().slice(0, 4) ? court : court + ' ' + annee;
}

/** Aujourd'hui, AAAA-MM-JJ, dans le fuseau de la famille. */
export function aujourdhui(): string {
  return jourLocal(new Date(), FUSEAU_FAMILLE);
}

export { MINUTES_RAPPEL } from '@camellie/shared';

import {
  champsDepuisEcheance as champsBase,
  isoDepuisDateEtHeure as isoBase,
} from '@camellie/shared';

/** Decompose une echeance pour pre-remplir les champs date et heure. */
export function champsEcheance(du_le: string | null): { date: string; heure: string } {
  return champsBase(du_le, FUSEAU_FAMILLE);
}

/**
 * Construit la valeur a stocker dans `du_le` a partir des deux champs.
 *
 * Sans date : null, la tache n'a pas d'echeance. Avec une date seule : on
 * stocke la date telle quelle, ce qui evite tout glissement de fuseau pour
 * une tache « dans la journee ». Avec une heure : un instant complet portant
 * le decalage de Montreal ce jour-la.
 */
export function echeanceDepuisChamps(date: string, heure: string): string | null {
  if (!date) return null;
  if (!heure) return date;
  return isoBase(date, heure, FUSEAU_FAMILLE);
}
